import React from 'react';

import { unit, white } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import View from '@zego/components/atoms/View';

import SecureFinance from '@zego/static/svgs/SecureFinance.svg';

const CoverByWakam = ({
  wrapperCss,
  textColor = white,
  icon = SecureFinance,
  text = 'Covered by A-rated financial strength reinsurers. 100% solvency checked (low-risk)',
  alt = 'Secure Finance',
}) => (
  <View
    css={{
      display: 'flex',
      alignItems: 'center',
      marginLeft: unit(1),
      width: '100%',
      ...wrapperCss,
    }}
  >
    <img css={{ paddingRight: unit(1) }} src={icon} alt={alt} />
    <RegularText
      css={{
        fontSize: 10,
        color: textColor,
        lineHeight: '13px',
      }}
    >
      {text}
    </RegularText>
  </View>
);

export default CoverByWakam;
